/* eslint-disable */

import { PAYMENT_DATA_FETCH_BEGIN, PAYMENT_DATA_FETCH_ERR, PAYMENT_DATA_FETCH_SUCCESS } from './actions';

const initialState = {
  payments: [],
  loading: false,
  error: null,
};

const paymentReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case PAYMENT_DATA_FETCH_BEGIN:
      return { ...state, payments: [], error: null, loading: true };
    case PAYMENT_DATA_FETCH_SUCCESS:
      return {
        ...state,
        payments: data,
        loading: false,
        error: null,
      };
    case PAYMENT_DATA_FETCH_ERR:
      return {
        ...state,
        error: err,
        payments: [],
        loading: false,
      };
    default:
      return state;
  }
};

export { paymentReducer };

